/**
 * The service to provide app which cannot be migrated to angular.
 * Contains all the methods needed for SharedAjsService.
 * Should migrate all Shared Ajs services when components migrated to angular
 */
import * as UserNotificationActionModal from 'raw-loader!src/app/public/app/shared/userNotifications/user-notifications-actions-modal.html';
var SharedAjsService = /** @class */ (function () {
    /*@ngInject*/
    function SharedAjsService($q, $http, $filter, $uibModal, modalService, $rootScope, $state, webSocketsService, StorageService, planService, genericServiceAjs, userService) {
        this.$q = $q;
        this.$http = $http;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.modalService = modalService;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.webSocketsService = webSocketsService;
        this.StorageService = StorageService;
        this.planService = planService;
        this.genericServiceAjs = genericServiceAjs;
        this.userService = userService;
        // From Job match service
        // Add to job match service after migrating above modules in constructor
        this.setRefreshJobMatchesListener();
        this.assessmentsSyncMessageListener = this.$q.defer();
    }
    SharedAjsService.prototype.schedulePhoneScreenOrInterview = function (type, scheduleData, successCallback, errorCallback) {
        var url = '';
        if (type == 'phoneScreen') {
            url = 'api/candidate/schedulephonescreen';
        }
        else if (type == 'interview') {
            url = 'api/candidate/scheduleinterview';
        }
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + url, scheduleData).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    SharedAjsService.prototype.rescheduleMeeting = function (meetingId, meetingObject, successCallback, errorCallback) {
        this.genericServiceAjs.addObject(this.StorageService.get('baseurl') + 'api/candidate/reschedulemeeting' + '/' + meetingId, meetingObject).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    //Assessments Sync message
    SharedAjsService.prototype.receiveAssessmentsSyncMessage = function () {
        return this.assessmentsSyncMessageListener.promise;
    };
    SharedAjsService.prototype.displayAssessmentsSyncMessage = function (htmlText) {
        this.assessmentsSyncMessageListener.notify(htmlText);
    };
    //shared methods
    SharedAjsService.prototype.onAssociateToJobClick = function (jobMatch, createJobMatchesObject, candidateName, canAssociateCallback, cannotAssociateCallback) {
        if (jobMatch.showOverride) {
            this._confirmOverrideSuspension(jobMatch, createJobMatchesObject, candidateName, canAssociateCallback, cannotAssociateCallback);
        }
        else if (jobMatch.allowManualMatch) {
            if (canAssociateCallback) {
                canAssociateCallback();
            }
        }
        else {
            this._showBootboxWarning(jobMatch.reasonForNoManualMatch);
        }
    };
    SharedAjsService.prototype._showBootboxWarning = function (message) {
        var _this = this;
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot associate candidate</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }, callback: function () {
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    };
    SharedAjsService.prototype._confirmOverrideSuspension = function (candidate, createJobMatchesObject, candidateName, canAssociateCallback, cannotAssociateCallback) {
        var _this = this;
        var message = candidate.reasonForNoManualMatch;
        var type = "release";
        var allowOverride = candidate.allowOverride;
        var suspendedMonths = 0;
        var releaseDate = '';
        var releasedJobDetails = {};
        if (candidate.overrideFor === "JOB_LEFT") {
            type = "jobLeft";
            suspendedMonths = candidate.jobLeftDetail.numberOfMonthsToWait;
            releaseDate = this.$filter('fourdotfiveDateFormat')(candidate.jobLeftDetail.leftAt);
            releasedJobDetails = candidate.jobLeftDetail;
        }
        else {
            suspendedMonths = candidate.releasedCandidateDetail.numberOfMonthsToWait;
            releaseDate = this.$filter('fourdotfiveDateFormat')(candidate.releasedCandidateDetail.releasedAt);
            releasedJobDetails = candidate.releasedCandidateDetail;
        }
        var candidateId = releasedJobDetails.candidateId;
        // if(type == 'release') {
        //     message = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
        //     message = message + "Candidate was previously released on '<span class='emerald'>" + $filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' "; 
        //     message = message + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'."
        // } else {
        //     message = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
        //     message = message + "Candidate left previous job on '<span class='emerald'>" + $filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' "; 
        //     message = message + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'."
        // }
        // message = message + "<br>Would you like to override?";
        if (allowOverride) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: message,
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Override',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                        var warningModal = _this.$uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            backdrop: 'static',
                            windowClass: 'four-dot-five-modal-medium',
                            templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/associateCandidates/associate-candidates-action-modal.html',
                            backdrop: false,
                            controller: ['$uibModalInstance', 'candidateId', 'candidateName', 'suspendedMonths', 'releaseDate', 'allowOverride', 'releasedJobDetails', 'type', function ($uibModalInstance, candidateId, candidateName, suspendedMonths, releaseDate, allowOverride, releasedJobDetails, type) {
                                    var ctrl = this;
                                    ctrl.candidateId = candidateId;
                                    ctrl.candidateName = candidateName;
                                    ctrl.suspendedMonths = suspendedMonths;
                                    ctrl.releaseDate = releaseDate;
                                    ctrl.allowOverride = allowOverride;
                                    ctrl.recruiterDetails = new OverrideNoteDetail(ctrl.candidateId);
                                    ctrl.releasedJobDetails = releasedJobDetails;
                                    ctrl.type = type;
                                    ctrl.modalTitle = "Override";
                                    ctrl.saveCallback = function () {
                                        if (type === 'release') {
                                            candidate.releasedCandidateDetail.releasedAt = null;
                                        }
                                        else {
                                            candidate.jobLeftDetail.leftAt = null;
                                        }
                                        createJobMatchesObject.overrideNoteDetails.push(ctrl.recruiterDetails);
                                        if (canAssociateCallback) {
                                            canAssociateCallback();
                                        }
                                        $uibModalInstance.close('cancel');
                                    };
                                    ctrl.closeModal = function () {
                                        // vm.removeCandidate(candidate);
                                        if (cannotAssociateCallback) {
                                            cannotAssociateCallback();
                                        }
                                        $uibModalInstance.close('cancel');
                                    };
                                }],
                            controllerAs: 'associateCandidatesActionModal',
                            size: 'md',
                            resolve: {
                                candidateId: function () {
                                    return candidateId;
                                },
                                candidateName: function () {
                                    return candidateName;
                                },
                                suspendedMonths: function () {
                                    return suspendedMonths;
                                },
                                releaseDate: function () {
                                    return releaseDate;
                                },
                                allowOverride: function () {
                                    return allowOverride;
                                },
                                releasedJobDetails: function () {
                                    return releasedJobDetails;
                                },
                                type: function () {
                                    return type;
                                }
                            }
                        });
                    }
                    else {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
        else {
            var displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot associate candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    if (cannotAssociateCallback) {
                        cannotAssociateCallback();
                    }
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    };
    SharedAjsService.prototype.setRefreshJobMatchesListener = function () {
        this.refreshJobMatchesListener = this.$q.defer();
    };
    SharedAjsService.prototype.raiseRefreshJobMatchesEvent = function (candidateId, jobMatchesActiveTab) {
        this.refreshJobMatchesListener.notify({ candidateId: candidateId, jobMatchesActiveTab: jobMatchesActiveTab });
    };
    SharedAjsService.prototype.receiveRefreshJobMatchesEvent = function () {
        return this.refreshJobMatchesListener.promise;
    };
    SharedAjsService.prototype.resetRefreshJobMatchesListener = function () {
        this.refreshJobMatchesListener.resolve();
        this.setRefreshJobMatchesListener();
    };
    // Move to user service after migrating routes
    SharedAjsService.prototype.navigateUserAfterLogin = function (userObject, loginParamsObject) {
        this.$rootScope.userActive = true;
        var stateObject = {
            loginParamsObject: loginParamsObject
        };
        this.StorageService.set('userDetails', this._createUserDetailsObject(userObject), { 'expires': new Date(Date.now() + this.$rootScope.tokenvalidity) });
        this.$rootScope.userDetails = this.StorageService.get('userDetails');
        if (this.$rootScope.userDetails.roleScreenRef.role.name === '4dot5SuperUser') {
            this.$state.go('missioncontrol.teamMembers');
        }
        else if (this.$rootScope.userDetails.policyChanged) {
            this.$state.go("missioncontrol.changePassword", { message: "Password restrictions have been changed. Please change the password to proceed.", policyChangePasswordUpdate: true });
        }
        else if (this.$rootScope.userDetails.plan.planName == 'Vendor Only') {
            this.$state.go('missioncontrol.requisitions', stateObject, { reload: false });
        }
        else {
            this.$state.go('missioncontrol.dashboard', stateObject, { reload: false });
        }
        this.webSocketsService.connect();
        if (this.$rootScope.userDetails.roleScreenRef.role.name != '4dot5SuperUser') {
            var userCacheObject = {
                userId: this.$rootScope.userDetails.id,
                loggedInCompanyId: this.$rootScope.userDetails.company.companyId
            };
            // Invoke user cache in order to save the users in in-memory-cache.
            this.userService.userCache(userCacheObject, function () { }, function (error) { console.log(error); });
        }
    };
    SharedAjsService.prototype._setLoginParameters = function (location) {
        return {
            redirect: location.redirect,
            candidateName: location.cn,
            candidateId: location.c,
            jobMatchId: location.jm,
            candidateType: location.ct,
            jobMatchJobId: location.j,
            isLogin: location.redirect ? true : false
        };
    };
    SharedAjsService.prototype.goToCandidateDocuments = function (actionType, actionLabel, candidateObj) {
        var windowClass = 'four-dot-five-modal-large';
        if (actionType == 'emailNotification') {
            windowClass = 'four-dot-five-modal-medium';
        }
        this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: UserNotificationActionModal.default,
            backdrop: 'static',
            keyboard: false,
            controller: ['$uibModalInstance', 'actionType', 'actionLabel', 'documentDtoMap', function ($uibModalInstance, actionType, actionLabel, documentDtoMap) {
                    var vm = this;
                    this.actionType = actionType;
                    this.actionLabel = actionLabel;
                    this.documentDtoMap = documentDtoMap;
                    this.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                }],
            windowTopClass: windowClass,
            controllerAs: 'userNotificationsActionModal',
            size: 'lg',
            resolve: {
                actionType: function () {
                    return actionType;
                },
                actionLabel: function () {
                    return actionLabel;
                },
                documentDtoMap: function () {
                    return candidateObj;
                }
            }
        });
    };
    SharedAjsService.prototype.viewDocumentFIle = function (file, successCallback, errorCallback) {
        var actionType = 'viewDocument';
        var actionLabel = file.fileName ? file.fileName : 'Document';
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        var viewDocumentFileModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-large',
            component: 'candidateProfileActionsModal',
            resolve: {
                actionType: function () {
                    return actionType;
                },
                actionLabel: function () {
                    return actionLabel;
                },
                document: function () {
                    return file;
                }
            }
        });
        viewDocumentFileModal.result.then(function (callbackObject) {
            if (successCallback) {
                successCallback(callbackObject);
            }
        }, function (dismiss) {
            if (errorCallback) {
                errorCallback(dismiss);
            }
        });
    };
    SharedAjsService.prototype._createUserDetailsObject = function (data) {
        var obj = {};
        obj.company = {};
        obj.plan = {};
        obj.id = data.id;
        obj.firstname = data.firstname;
        obj.lastname = data.lastname;
        obj.emailId = data.emailId;
        obj.companyId = data.companyId;
        obj.policyChanged = data.policyChanged;
        // obj.accesstoken = data.token;
        obj.company.companyId = data.company.companyId;
        obj.company.companyName = data.company.companyName;
        obj.company.companyType = data.company.companyType;
        obj.company.companyState = data.company.companyState;
        obj.company.companyStateLabel = data.company.companyState == 'SoftHold' ? 'Soft Hold' : data.company.companyState;
        obj.company.message = data.company.message;
        obj.plan.planName = data.planMinDto.planName;
        obj.plan.planType = data.planMinDto.planType;
        obj.plan.startDate = moment(data.planMinDto.planStartDate);
        obj.plan.endDate = moment(data.planMinDto.planEndDate);
        obj.plan.message = this.planService.getPlanExpiryMessage(obj.plan.planType, obj.plan.endDate, true);
        ;
        obj.accountState = data.accountState;
        obj.shouldPopupBeDisplayed = data.shouldPopupBeDisplayed;
        obj.roleScreenRef = this._createRoleScreenRefObj(data.roleScreenRef);
        if (data.roleScreenRef.role.name !== '4dot5SuperUser' && data.roleScreenRef.role.name !== '4dot5Admin') {
            obj.company.companySelected = true;
        }
        else {
            obj.company.companySelected = false;
        }
        return obj;
    };
    SharedAjsService.prototype._createRoleScreenRefObj = function (roleScreenRef) {
        var roleObj = {};
        roleObj.role = {};
        roleObj.role.id = roleScreenRef.role.id;
        roleObj.role.name = roleScreenRef.role.name;
        roleObj.screen = this._manageScreenListForRoles(roleScreenRef.screen);
        return roleObj;
    };
    SharedAjsService.prototype._manageScreenListForRoles = function (screenlist) {
        for (var i = 0; i < screenlist.length; i++) {
            delete screenlist[i].name;
        }
        return screenlist;
    };
    SharedAjsService.prototype.navigateToHomeScreen = function (loginParamsObject) {
        var stateObject = {
            loginParamsObject: loginParamsObject
        };
        if (this.$rootScope.userDetails.roleScreenRef.role.name === '4dot5SuperUser' && this.$rootScope.userDetails.company.companyType == "Host") {
            this.$state.go('missioncontrol.teamMembers');
        }
        else if (this.$rootScope.userDetails.policyChanged) {
            this.$state.go("missioncontrol.changePassword", { message: "Password restrictions have been changed. Please change the password to proceed.", policyChangePasswordUpdate: true });
        }
        else if (this.$rootScope.userDetails.plan.planName == 'Vendor Only') {
            this.$state.go('missioncontrol.requisitions', stateObject, { reload: false });
        }
        else {
            this.$state.go('missioncontrol.dashboard', stateObject, { reload: false });
        }
    };
    return SharedAjsService;
}());
export { SharedAjsService };
//# sourceMappingURL=sharedAjsService.js.map